export default {
  "authenticator": "Authenticator",
  "recovery": "Recovery",
  "password": "Password",
  "tokenMissingRefresh": "Missing security token. Refresh the page.",
  "tokenMissing": "Missing security token.",
  "registrationFailed": "Passkey registration failed.",
  "registered": "Passkey registered.",
  "renameTitle": "Rename passkey",
  "renameDescription": "Enter a new name for this passkey.",
  "passkeyName": "Passkey name",
  "name": "Name",
  "save": "Save",
  "renameFailed": "Unable to rename passkey.",
  "updated": "Passkey updated.",
  "removeTitle": "Remove passkey",
  "removeDescription": "Are you sure you want to remove this passkey? You won't be able to use it to sign in anymore.",
  "remove": "Remove",
  "removeFailed": "Unable to remove passkey.",
  "removed": "Passkey removed.",
  "enrollmentFailed": "Unable to start enrollment.",
  "codeVerificationFailed": "Unable to verify code.",
  "enabled": "Two-factor authentication enabled.",
  "disableFailed": "Unable to disable 2FA.",
  "disabled": "Two-factor authentication disabled.",
  "regenerateFailed": "Unable to regenerate recovery codes.",
  "regenerated": "Recovery codes regenerated.",
  "passkeys": "Passkeys",
  "passkeysDescription": "Passwordless sign-in for supported devices.",
  "loading": "Loading passkeys…",
  "empty": "No passkeys registered yet. Add a passkey to speed up sign-in.",
  "registeredCount_one": "{{formattedCount}} passkey registered.",
  "registeredCount_other": "{{formattedCount}} passkeys registered.",
  "registeredCount_many": "{{formattedCount}} passkeys registered.",
  "passkeyLabel": "Passkey label (optional)",
  "add": "Add passkey",
  "timestamps": "Created {{created}} · Last used {{used}}",
  "rename": "Rename",
  "twoFactor": "Two-Factor Authentication",
  "twoFactorDescription": "Add a second layer of security.",
  "twoFactorDisabled": "2FA is currently disabled. Enable it to protect your account.",
  "enable": "Enable 2FA",
  "qrAlt": "2FA QR code",
  "scan": "Scan with your authenticator app.",
  "manualSetup": "Manual setup",
  "manualInstructions": "Use this key if you can’t scan the QR code:",
  "verificationCode": "Verification code",
  "verifyEnable": "Verify & enable",
  "twoFactorEnabled": "2FA is enabled",
  "enabledDescription": "Your account now requires a second factor when signing in.",
  "recoveryCodes": "Recovery codes",
  "recoveryWarning": "Save these codes in a safe place. They can only be viewed once.",
  "verificationMethod": "Verification method",
  "accountPassword": "Account password",
  "regenerate": "Regenerate recovery codes",
  "disable": "Disable 2FA",
  "browserRequired": "Passkeys require a browser context.",
  "secureContextRequired": "Passkeys require a secure context (HTTPS or localhost).",
  "webAuthnUnavailable": "WebAuthn is not available in this browser.",
  "passkeysUnavailable": "Passkeys are not available on this device.",
  "creationCanceled": "Passkey creation was canceled or timed out.",
  "domainNotAllowed": "Passkeys are not allowed for this domain. Check HTTPS and RP ID settings.",
  "credentialExists": "A passkey already exists for this account on this device.",
  "deviceUnsupported": "Passkeys are not supported on this device.",
  "authenticatorFailed": "Passkey creation failed. Try a different authenticator.",
  "operationFailed": "Passkey operation failed.",
  "registrationStartFailed": "Unable to start passkey registration.",
  "optionsUnavailable": "Passkey options unavailable.",
  "verificationFailed": "Passkey verification failed."
} as const;
